import { Modal, Typography } from "antd";
const AreYouSure = ({ isOpen, onOk, onCancel }) => {
  return (
    <>
      <Modal
        title="Are you sure?"
        centered
        open={isOpen}
        onCancel={onCancel}
        okText="Submit to QC"
        onOk={onOk}
        width={440}
      >
        <Typography className="text-sm mb-4">
          Upon saving this order system will be sending the order request for QC
          approval. Please click
        </Typography>
      </Modal>
    </>
  );
};
export default AreYouSure;
